import type { App } from "vue";
import {
  AuthDataSourceImpl,
  authDataSourceKey,
} from "./data/datasources/auth_datasource";

export function initAuthModule(app: App) {
  app.provide(authDataSourceKey, new AuthDataSourceImpl());
}
